export default {
  labels: {
    selectOne: "Bir seçenek seçin",
    selectAll: "Uygun olan tüm seçenekleri seçin",
    typeResponse: "Cevabınızı aşağıdaki metin kutusuna yazın.",
    recordResponse: "Soruyu yanıtlamak için bir kayıt oluşturun.",
    enterNumeric: "Aşağıdaki alana sayısal bir yanıt girin.",
    rateResponseScale: "Cevabınızı verilen ölçeğe göre değerlendirin.",
    sliderMinimum: 'Minimum değer: {value}',
    sliderMaximum: 'Maksimum değer: {value}',
    selectOneOptionRow: "Her satırda bir seçenek seçin.",
    selectAllOptionsRow: "Her satır için geçerli tüm seçenekleri seçin.",
    dragAndDropResponse: "Tercih sırasına göre sıralamak için seçenekleri sürükleyip bırakın.",
    rankOrderDesktopInstruction: 'Öğeleri sıralamak için sürükleyip bırakın ya da + düğmesini kullanarak listeye öğe ekleyin. Yeniden sıralamak için ok düğmelerini veya öğeyi kaldırmak için silme düğmesini kullanın.',
    alert: "Uyarı",
    error: 'Lütfen {min} ile {max} arasında bir sayı girin.',
    cameras: 'Kameralar',
    microphones: 'Mikrofonlar',
    recording: 'Kayıt',
    noDevicesFound: 'Cihaz bulunamadı',
    camera: 'Kamera',
    microphone: 'Mikrofon',
    stopRecording: 'Kaydı durdur',
    startRecording: 'Kaydı başlat',
    disableCamera: 'Kamerayı Devre Dışı Bırak',
    enableCamera: 'Kamerayı Etkinleştir',
    disableMicrophone: 'Mikrofonu Devre Dışı Bırak',
    enableMicrophone: 'Mikrofonu Etkinleştir',
    settings: 'Ayarlar',
    recordingProgress: 'Kayıt İlerlemesi',
    playbackProgress: 'Oynatma İlerlemesi',
    play: 'Oynat',
    pause: 'Duraklat',
    stop: 'Durdur',
    record: 'Kaydet',
    recordAgain: 'Yeniden kaydet',
    retry: 'Yeniden dene',
    done: 'Bitti',
    minRecordTime: 'Lütfen {min} saniye boyunca bir yanıt kaydedin.',
    enlargeImage: 'Görseli büyüt',
    enlargedImage: 'Büyütülmüş görsel',
    close: 'Kapat',
    zoomIn: 'Yakınlaştır',
    zoomOut: 'Uzaklaştır',
    resetZoom: 'Yakınlaştırmayı sıfırla',
    zoomLevel: 'Yakınlaştırma {percentage}%',
    imagePosition: '{current} / {total}',
    previousImage: 'Önceki görsel',
    nextImage: 'Sonraki görsel',
    imageLoading: 'Görsel yükleniyor',
    imageLoadFailed: 'Görsel yüklenemedi',
  },
  noSelection: "Seçim yok",
  actions: {
    increase: 'Artır',
    decrease: 'Azalt'
  },
  survey: {
    endOfSurvey: {
      titleTerminated: 'Anket Önizlemesi Sonlandırıldı',
      titleCompleted: 'Anket Önizlemesi Tamamlandı',
      previewModeWarning: 'Bu sayfa yalnızca Önizleme Modunda görünür ve gerçek katılımcılara gösterilmez.',
      reachedEndPoint: 'Bu anket bir bitiş noktasına ulaştı.',
      reachedEndPointCompleted: 'Bu önizleme bir bitiş noktasına ulaştı.',
      returnToModify: 'Yanıtlarınızı değiştirmek ve farklı bir anket yolunu test etmek için önceki soruya dönün.',
      logic: 'Mantık'
    }
  }
}
